import { ENV } from './config.js';

export async function FetchNotifications( token ) {
    const response = await fetch( `https://${ ENV }api.biw.cloud/v1/notification-deck-service/notifications`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            'authorization': `Bearer ${ token }`
        }
    } );

    const data = await response.json();
    return data;
}

export async function UpdateStatus( token, id, status ) {
    const response = await fetch( `https://${ ENV }api.biw.cloud/v1/notification-deck-service/notifications/${ id }/status`, {
        method: 'PUT',
        headers: {
            'content-type': 'application/json',
            'authorization': `Bearer ${ token }`
        },
        body: JSON.stringify( { status: status } )
    } );

    const data = await response.json();
    return data;
}

export async function DeleteNotification( token, id ) {
    const response = await fetch( `https://${ ENV }api.biw.cloud/v1/notification-deck-service/notifications/${ id }`, {
        method: 'DELETE',
        headers: {
            'content-type': 'application/json',
            'authorization': `Bearer ${ token }`
        }
    } );

    const data = await response.json();
    return data;
}
